import { DEPLOYMENT_MESSAGE_MAX_LENGTH } from "./deployment-message.js";
import { z } from "zod";
// One row per target and service for the operator-facing fleet overview served
// by admin-control at GET /api/admin/fleet/overview. Rollout records are pushed
// by the box that is being deployed (fleet CLI and app deploy), health by the
// target reporter; this view only joins what was received.
export const fleetDeploymentPhaseSchema = z.enum([
    "queued",
    "starting",
    "deploying",
    "ready",
    "traffic_shifted",
    "verifying",
    "complete",
    "failed",
    "rolled_back",
]);
const slugSchema = z.string().regex(/^[a-z0-9][a-z0-9-]{0,63}$/u);
const identifierSchema = z.string().min(1).max(128);
const timestampSchema = z.string().min(1).max(64);
export const fleetServiceRolloutSchema = z.object({
    service: slugSchema,
    /** Null when the service was only seen in the target's health report. */
    phase: fleetDeploymentPhaseSchema.nullable(),
    release: identifierSchema.nullable(),
    deploymentId: identifierSchema.nullable(),
    rolloutId: identifierSchema.nullable(),
    startedAt: timestampSchema.nullable(),
    updatedAt: timestampSchema.nullable(),
    message: z.string().max(DEPLOYMENT_MESSAGE_MAX_LENGTH).nullable(),
    /** A non-terminal phase whose record stopped updating. */
    stale: z.boolean(),
    /** Which path produced the record: the governed train or an operator's fleet CLI. */
    origin: z.enum(["train", "manual", "staging"]).nullable(),
    /** The release marker the target's health reporter last saw for this service. */
    reportedRelease: z.string().max(160).nullable(),
}).strict();
export const fleetTargetHealthSchema = z.object({
    status: z.enum(["ok", "failing", "stale", "missing"]),
    reportedAt: timestampSchema.nullable(),
    ageMs: z.number().int().nonnegative().nullable(),
    failingChecks: z.array(z.string().max(120)).max(64),
}).strict();
export const fleetTargetOverviewSchema = z.object({
    target: slugSchema,
    role: z.string().max(32),
    label: z.string().max(240).nullable(),
    tailscaleIp: z.string().max(64).nullable(),
    health: fleetTargetHealthSchema,
    /** The whole-target rollout record the fleet CLI publishes as service "rollout". */
    rollout: fleetServiceRolloutSchema.nullable(),
    services: z.array(fleetServiceRolloutSchema).max(64),
}).strict();
export const fleetOverviewResponseSchema = z.object({
    generatedAt: z.number().int().nonnegative(),
    targets: z.array(fleetTargetOverviewSchema).max(64),
}).strict();
